
export enum ActionType {
    OPEN_PAYMENT_DIALOG = 'OPEN_PAYMENT_DIALOG'
}

export interface ActionPaymentDialog {
    type: ActionType.OPEN_PAYMENT_DIALOG,
    isOpen : boolean
}

type Action = ActionPaymentDialog

export default Action